import * as z from "zod";
import { IconNameSchema } from "./icons";

export type CompiledJsxNode =
  | { kind: "text"; value: string }
  | { kind: "value"; value: unknown }
  | { kind: "fragment"; children: CompiledJsxNode[] }
  | {
      kind: "element";
      name: string;
      props: Record<string, unknown>;
      desktopProps?: Record<string, unknown>;
      children: CompiledJsxNode[];
    };

export const CompiledJsxNodeSchema: z.ZodType<CompiledJsxNode> = z.lazy(() =>
  z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("text"), value: z.string() }),
    z.object({ kind: z.literal("value"), value: z.unknown() }),
    z.object({ kind: z.literal("fragment"), children: z.array(CompiledJsxNodeSchema) }),
    z.object({
      kind: z.literal("element"),
      name: z.string(),
      props: z.record(z.string(), z.unknown()),
      desktopProps: z.record(z.string(), z.unknown()).optional(),
      children: z.array(CompiledJsxNodeSchema),
    }),
  ]),
);

export const CompiledJsxSectionSchema = z.object({
  mobileTree: CompiledJsxNodeSchema.nullable(),
  desktopTree: CompiledJsxNodeSchema.nullable(),
  iconNames: z.array(IconNameSchema).optional(),
});
export type CompiledJsxSection = z.infer<typeof CompiledJsxSectionSchema>;
export const CompiledJsxSectionsSchema = z.record(z.string(), CompiledJsxSectionSchema);
export type CompiledJsxSections = z.infer<typeof CompiledJsxSectionsSchema>;
